<template>
  <v-app id="inspire" style="background: #f8f9fb">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <app-header />
            <v-card class="auth-card mx-auto" max-width="460" elevation="0">
              <div class="auth-head">
                <h2 class="auth-title">Create a password</h2>
                <p class="auth-sub">
                  Set a new password to secure your account
                </p>
              </div>
              <v-form ref="createPassword" v-model="valid">
                <v-text-field
                  label="Password"
                  name="new-password"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  v-model="password"
                  @keyup="runValidation()"
                  :rules="[
                    required('Password'),
                    minLength('password', 8),
                    lowerCaseFormat(),
                    upperCaseFormat(),
                    digitFormat(),
                    specialCharFormat(),
                  ]"
                  @click:append="show = !show"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  label="Confirm password"
                  name="confirmPassword1"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  v-model="confirmPassword1"
                  :rules="[
                    required('password'),
                    confirmPassword('password', password),
                  ]"
                  @click:append="show1 = !show1"
                  outlined
                  dense
                ></v-text-field>

                <v-btn
                  block
                  large
                  class="auth-btn mt-2"
                  @click="createPassword"
                  :disabled="!valid"
                  :loading="loading"
                  >Submit Password</v-btn
                >
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <app-bottom />
  </v-app>
</template>

<script>
import validations from '@/utils/Validations'
import { mapState } from 'vuex'
export default {
  components: {
    appHeader: () => import('@/components/Logo'),
    appBottom: () => import('@/components/BottomImage'),
  },
  props: {
    source: String,
  },
  data() {
    return {
      valid: false,
      password: '',
      confirmPassword1: '',
      show: false,
      show1: false,
      reValidateConfirmPassword: false,
      ...validations,
    }
  },

  computed: {
    ...mapState(['loading']),
  },

  methods: {
    createPassword() {
      this.$store.state.loading = true

      const formData = {
        password: this.password,
      }

      this.$store.dispatch('createPassword', formData)
    },

    runValidation: function () {
      if (this.confirmPassword1 && this.password)
        this.$refs.createPassword.validate()
    },
  },
}
</script>

<style scoped>
.auth-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(15, 42, 85, 0.12);
  padding: 28px 30px 30px;
}
.auth-head {
  text-align: center;
  margin-bottom: 18px;
}
.auth-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.auth-sub {
  font-size: 13px;
  color: #6b7a90;
  margin-top: 4px;
}
.auth-link {
  color: #034ea2;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
}
.auth-link:hover {
  text-decoration: underline;
}
.auth-btn {
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%) !important;
  color: #ffffff !important;
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  box-shadow: 0 8px 20px rgba(3, 78, 162, 0.3);
}
.auth-btn.v-btn--disabled {
  background: #e6ebf3 !important;
  color: #4b5a70 !important;
  box-shadow: none;
}
/* Soft rounded inputs */
.auth-card ::v-deep .v-text-field--outlined .v-input__slot {
  border-radius: 10px;
}
.auth-card ::v-deep .v-text-field--outlined fieldset {
  border-color: #d6deea;
}
.auth-card ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #034ea2;
}
</style>
